<template>
  <div ref="imageRef" class="image-container">
    <img src="@/assets/IMG_7905-4.jpg"

      alt="Imagen de ejemplo"
      class="cover-image"
    />
    <div class="overlay"></div>
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'CoverImageComponent',
  setup() {
    const imageRef = ref(null);

    onMounted(async () => {
      await nextTick();

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              gsap.fromTo(
                imageRef.value,
                {
                  opacity: 0,
                  scale: 1.05,
                  y: 50
                },
                {
                  opacity: 1,
                  scale: 1,
                  y: 0,
                  duration: 1.5,
                  ease: 'power3.out'
                }
              );
            }
          });
        },
        { threshold: 0.3 }
      );

      if (imageRef.value) {
        observer.observe(imageRef.value);
      }
    });

    return { imageRef };
  }
};
</script>

<style scoped>
.image-container {
  width: 100%;
  max-height: 90vh;
  overflow: hidden;
  position: relative;
  opacity: 0;
  transform: scale(1.02);
}

.cover-image {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
  object-fit: contain;
  image-rendering: auto;
  filter: none;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(219, 213, 213, 0.1), rgba(227, 227, 221, 0.2));
  pointer-events: none;
}
</style>
